export function getFaqAccordionStyles(_, { palette }) {
  return {
    faqAccordionContainer: {
      width: '100%',
      background: '#FFFFFF',
      boxShadow: '-1px -1px 2px rgba(0, 0, 0, 0.1), 1px 1px 2px rgba(0, 0, 0, 0.1)',
      borderRadius: '4px',
    },
    faqPanelTitle: {
      width: '100%',
      height: '67px',
      paddingLeft: '24px',
      border: '0',
      background: '#FFFFFF',
      display: 'flex',
      alignItems: 'center',
      '@media only screen and (max-width: 720px)': {
        paddingLeft: '8px',
      },
    },
    faqPanelTitleTextOpen: {
      width: '100%',
      display: 'flex',
      textAlign: 'start',
      fontSize: '20px',
      fontWeight: '600',
      color: palette.black,
      '@media only screen and (max-width: 720px)': {
        fontSize: '16px',
      },
    },
    faqPanelTitleTextClose: {
      width: '100%',
      display: 'flex',
      textAlign: 'start',
      fontSize: '20px',
      color: palette.black,
      '@media only screen and (max-width: 720px)': {
        fontSize: '16px',
      },
    },
    faqPanelTitleIconOpen: {
      width: '67px',
      fontSize: '24px',
      transform: 'rotate(180deg)',
      transition: 'transform 0.1s linear',
    },
    faqPanelTitleIconClose: {
      width: '67px',
      fontSize: '24px',
      transform: 'rotate(0deg)',
      transition: 'transform 0.1s linear',
    },
    faqPanel: {
      width: '100%',
      padding: '0 67px 0 10px',
      fontSize: '20px',
      whiteSpace: 'break-spaces',
      '@media only screen and (max-width: 720px)': {
        fontSize: '16px',
        padding: '0 67px 0 0',
      },
    },
  };
}
